<template>
	<div>
		<Arrow_increase v-if="numValue > numComparated" />
		<Arrow_equal v-else-if="numValue === numComparated" />
		<Arrow_decrease v-else />
	</div>
</template>

<script setup>
import { computed } from 'vue';
import Arrow_equal from './svg/arrow_equal.vue';
import Arrow_increase from './svg/arrow_increase.vue';
import Arrow_decrease from './svg/arrow_decrease.vue';

const props = defineProps({
	value: {
		type: Number,
		required: false,
		default: 0,
	},
	comparated: {
		type: Number,
		required: false,
		default: 0,
	},
});

const numValue = computed(() => {
	return Number(props.value) || 0;
});

const numComparated = computed(() => {
	return Number(props.comparated) || 0;
});
</script>
